import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, FieldTypes, useResponsive, validatePhoneNumber } from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';

export interface FormValues {
  phoneNumber: string;
}

interface Props {
  phoneNumber?: string;
  errorText?: string;
}

const usePhoneVerificationFields = ({ phoneNumber, errorText }: Props) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: 'phoneNumber',
        type: FieldTypes.PhoneNumber,
        label: 'Phone number',
        placeholder: '+1',
        showRequireIcon: true,
        defaultValue: phoneNumber,
        style: isMobile ? undefined : { display: 'grid', gridTemplateColumns: 'minmax(200px, 1fr) 320px' },
        validator: yup.string().test(validatePhoneNumber()).required(t(REQUIRED_TEXT)),
        manualError: errorText,
      },
    ],
    [phoneNumber, t, errorText, isMobile]
  );

  return fields;
};

export default usePhoneVerificationFields;
